import {
  Avatar,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Link,
  makeStyles,
  TextField,
  TextFieldProps,
  Typography,
} from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { signedIn } from 'store/slices/auth-slice'
import { SigninInfo, useSignin } from '../api'
import React, { useState } from 'react'
import { LockIcon } from '../icons'
import { useCaptcha } from '../Captcha'
import { Link as RouterLink } from 'react-router-dom'
import { strings } from '../strings'
import { PasswordField } from '../PasswordField'

export function SignIn() {
  // const APP_CONFIG = JSON.parse(localStorage.getItem('config') ?? '{}')

  const title = "DZR Caster"

  const dispatch = useDispatch()
  const signin = useSignin()
  const [captcha, refreshCaptcha, getCaptchaInfo] = useCaptcha()
  const { register, handleSubmit, errors } = useForm<SigninInfo>()
  const [message, setMessage] = useState({ error: false, text: '' })
  const [remember, setRemember] = useState(true)

  const onSubmit = (formData: SigninInfo) => {
    const captchaInfo = getCaptchaInfo()

    signin(formData, captchaInfo)
      .then((token) => {
        dispatch(signedIn(token))

        localStorage.removeItem('auth-token')
        sessionStorage.removeItem('auth-token')

        if (remember) {
          localStorage.setItem('auth-token', token)
        } else {
          sessionStorage.setItem('auth-token', token)
        }
      })
      .catch((err) => {
        setMessage({ error: true, text: err.message })
        refreshCaptcha()
      })
  }

  const classes = useStyles()

  return (
    <div className={classes.paper}>
      <Typography variant="h6" className={classes.title}>
        {title}
        {/* <br />
        <span style={{ color: 'red', fontSize: '1rem' }}>(نسخه آزمایشی)</span> */}
      </Typography>
      <Avatar className={classes.avatar}>
        <LockIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        ورود
      </Typography>
      <form
        className={classes.form}
        noValidate
        onSubmit={handleSubmit(onSubmit)}
      >
        <CustomTextField
          name="username"
          label={strings.usernameOrNatinalCode}
          inputRef={register({ required: true, minLength: 4 })}
          error={!!errors.username}
          autoFocus
        />
        <PasswordField
          name="password"
          label={strings.password}
          inputRef={register({ required: true, minLength: 4 })}
          error={!!errors.password}
          margin="normal"
          autoComplete="off"
          variant="outlined"
          fullWidth
        />
        {captcha}
        <Typography color={message.error ? 'error' : 'primary'}>
          {message.text}
        </Typography>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          ورود
        </Button>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
            />
          }
          label="مرا به خاطر بسپار"
        />
        <Grid container>
          <Grid item xs>
            <Link component={RouterLink} to="/auth/forgot">
              رمز را فراموش کردم
            </Link>
          </Grid>
          <Grid item>
            <Link component={RouterLink} to="/auth/signup">
              حساب ندارید؟ ثبت نام
            </Link>
          </Grid>
        </Grid>
      </form>
    </div>
  )
}

function CustomTextField(props: TextFieldProps) {
  return (
    <TextField
      margin="normal"
      autoComplete="off"
      variant="outlined"
      fullWidth
      {...props}
    />
  )
}

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(0, 4, 8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    margin: theme.spacing(1, 0, 3, 0),
    textAlign: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))
